
import { FormElementController, FormPageValidator, FormElementValidator, StringValidators, ValidationResult, FormElementStatus } from './../../../scripts/formcontrols'
import { DrugDto } from "./../../../dto/DrugDto"


export default class DrugSearchController extends FormPageValidator {

    drug: FormElementController<DrugDto>;

    constructor() {
        super();

        var drugValidator = new FormElementValidator<DrugDto>(true, (d) => {
            
            if (d.apid || d.vpid) {
                return new ValidationResult(FormElementStatus.Success,"");
            }

            return new ValidationResult(FormElementStatus.Error, "Drug selection is mandatory");
        });

        this.drug = new FormElementController<DrugDto>("Drug", new DrugDto(), drugValidator);

        this.addValidators(drugValidator);
    }

}


// WEBPACK FOOTER //
// ./ClientApp/components/appcontrols/DrugSearchSelector/DrugSearchSelectorController.ts